enum FocusGuide {
  Top = 'top',
  Middle = 'middle',
  Bottom = 'bottom',
  None = 'none',
}

export default FocusGuide;